export const myProjectData = [
    {
        id: 1,
        title : 'shopeclues',
        image_url : 'images/project1.png',
        category : 'React',
        description : 'I build this app by using react.js and tailwind css. This is a eccomrcial app with entractive UI and filter product fucntionality',
        url : 'https://my-shopclues-massi.vercel.app/'
    },
    {
        id: 2,
        title : 'Basic Filter',
        image_url : 'images/project2.png',
        category : 'React',
        description : 'This app has a basic filter functionality , i practice this project with react , contaxt api useReducer axios and many more hooks',
        url : 'https://massi-react-filter.netlify.app/'
    },
    {
        id: 3,
        title : 'Netflix Clone',
        image_url : 'images/project3.png',
        category : 'react',
        description : 'Creating Netflix online movie streaming app using themoviedb API. I have use react, typescript , tailwind css , redux toolkit , redux-thunk',
        url : 'https://massimoviesflix.netlify.app/'
    },
    {
        id: 7,
        title : 'To-Do-List App',
        image_url : 'images/project7.png',
        category : 'Next',
        description : 'Empliment the to-do-list functionality with nextjs , tailwind css , redux toolkit and different type of react hooks',
        url : 'https://todolist-massi.netlify.app'
    },
    {
        id: 4,
        title : 'Dashboard',
        image_url : 'images/project4.png',
        category : 'React',
        description : 'I am creating this UI of dashboard here, you can see defferent chart like bar chart, pia chart etc using chart.js ',
        url : 'https://mashirull.github.io/react-admin-panel/'
    },
    {
        id: 5,
        title : 'Weather App',
        image_url : 'images/project5.png',
        category : 'React',
        description : 'Weather app that can get weather of city by searching city name and display current weather of that city with beatifull looking UI using React.js',
        url : 'https://mashirull.github.io/weather-app/'
    },
    {
        id: 6,
        title : 'Eccomerce',
        image_url : 'images/project6.png',
        category : 'Jquery',
        description : 'Eccomerce app by using HTML CSS  and JQUERY . displying all the product with category like accesorise and clothing ',
        url : 'https://mashirull.github.io/Shopping-App-js-final-assignment/'
    },
    {
        id: 8,
        title : 'UI Design',
        image_url : 'images/project8.png',
        category : 'html-css-js',
        description : 'using HTML , CSS i build this UI only practice pure html5 and css3 .This is great looking app with responsivness ',
        url : 'https://mashirull.github.io/Assigment4/'
    },
    {
        id: 9,
        title : 'Quize App',
        image_url : 'images/project9.png',
        category : 'javascript',
        description : 'This is a Quize app by using  javascript. User can take quize and see result of the his quize.This is a practice app',
        url : 'https://mashirull.github.io/Assignment-5-Quiz-App/'
    },
    {
        id: 10,
        title : 'food delivery app (frontend)',
        image_url : 'images/project10.png',
        category : 'html-css-js',
        description : 'This is a food delivery app by using only HTML , CSS , and JAVASCRIPT . This app has multiple page and also responsive',
        url : ''
    }
]
